var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import OrderSuppData from "./OrderData/OrderSuppData";
var OrderExtras = /** @class */ (function (_super) {
    __extends(OrderExtras, _super);
    function OrderExtras(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.suppDatas = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        OrderExtras.buildFromJson(_this, obj);
        return _this;
    }
    OrderExtras.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'suppDatas') {
                        instance[prop] = [];
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance[prop].push(new OrderSuppData(subProp));
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    OrderExtras.prototype.exportToJson = function () {
        var exportJSON = {};
        if (this.email)
            exportJSON.email = this.email;
        if (this.fullname)
            exportJSON.fullname = this.fullname;
        if (this.firstname)
            exportJSON.firstname = this.firstname;
        if (this.lastname)
            exportJSON.lastname = this.lastname;
        if (this.companyName)
            exportJSON.companyName = this.companyName;
        if (this.personTitle)
            exportJSON.personTitle = this.personTitle;
        if (this._companyActivity_)
            exportJSON._companyActivity_ = this._companyActivity_;
        if (this._companyPostalCode_)
            exportJSON._companyPostalCode_ = this._companyPostalCode_;
        if (this.companyCity)
            exportJSON.companyCity = this.companyCity;
        if (this.companyCountry)
            exportJSON.companyCountry = this.companyCountry;
        if (this.comment)
            exportJSON.comment = this.comment;
        if (this._companyWorkforce_)
            exportJSON._companyWorkforce_ = this._companyWorkforce_;
        if (this._gender_)
            exportJSON._gender_ = this._gender_;
        if (this._phones_)
            exportJSON._phones_ = this._phones_;
        if (this.newsletterAgreement)
            exportJSON.newsletterAgreement = this.newsletterAgreement;
        exportJSON.suppDatas = [];
        for (var _i = 0, _a = this.suppDatas; _i < _a.length; _i++) {
            var suppData = _a[_i];
            exportJSON.suppDatas.push(suppData.exportToJson());
        }
        return exportJSON;
    };
    OrderExtras.prototype.setSuppDataValue = function (establishmentOrderSuppData, data) {
        for (var _i = 0, _a = this.suppDatas; _i < _a.length; _i++) {
            var suppData = _a[_i];
            if (suppData.establishmentOrderSuppDataUid === establishmentOrderSuppData.uid) {
                suppData.setData(establishmentOrderSuppData, data);
                return;
            }
        }
        // If it doesnt already exist
        var orderSuppData = new OrderSuppData();
        orderSuppData.establishmentOrderSuppDataUid = establishmentOrderSuppData.uid;
        orderSuppData.setData(establishmentOrderSuppData, data);
        this.suppDatas.push(orderSuppData);
    };
    OrderExtras.prototype.removeSuppData = function (establishmentOrderSuppData) {
        var found = false;
        var index = 0;
        for (var _i = 0, _a = this.suppDatas; _i < _a.length; _i++) {
            var suppData = _a[_i];
            if (suppData.establishmentOrderSuppDataUid === establishmentOrderSuppData.uid) {
                found = true;
                break;
            }
            index++;
        }
        if (found) {
            this.suppDatas.splice(index, 1);
        }
    };
    return OrderExtras;
}(Model));
export { OrderExtras };
//# sourceMappingURL=OrderExtras.js.map